import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { FilterAccordion } from "components/common/CustomFilters/FilterAccordion";
import { StudentEnrollmentFilter as StudentEnrollmentFilterModel, StudentEnrollmentFilterResource } from "generated/openApi";
import produce from "immer";

export const StudentEnrollmentFilterAccordion = (props: {
  resource?: StudentEnrollmentFilterResource;
  filter: StudentEnrollmentFilterModel;
  setFilter: (filter: StudentEnrollmentFilterModel) => void;
}) => {
  const properties = props.resource?.properties || [];
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();


  const schoolYearsField = () => {
    const propertyName = pn<StudentEnrollmentFilterModel>("schoolYears");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        multiple
        value={props.resource?.schoolYears?.filter((x) => props.filter.schoolYears?.includes(x.id))}
        options={props.resource!.schoolYears}
        getOptionLabel={option => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolYears = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const schoolsField = () => {
    const propertyName = pn<StudentEnrollmentFilterModel>("schoolIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        multiple
        value={props.resource?.schools?.filter((x) => props.filter.schoolIds?.includes(x.id))}
        options={props.resource?.schools}
        getOptionLabel={option => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={largeFieldBreakpoints}>
          {schoolYearsField()}
        </Grid>

        <Grid item xs={largeFieldBreakpoints}>
          {schoolsField()}
        </Grid>
      </Grid>
  );
};
